var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.4916 27.1749L29.5084 17.1581C29.964 16.7025 30.7027 16.7025 31.1583 17.1581L32.7995 18.7993C33.2547 19.2545 33.2552 19.9923 32.8007 20.4481L25.27 27.9998L32.8007 35.5515C33.2552 36.0073 33.2547 36.7451 32.7995 37.2003L31.1583 38.8415C30.7027 39.2971 29.964 39.2971 29.5084 38.8415L19.4916 28.8248C19.036 28.3692 19.036 27.6305 19.4916 27.1749Z",
  fill: "white"
})));
export default SvgArrowLeft1;